module.exports = __webpack_public_path__ + "static/text_serviceen.876371b1.png";